// extracted by mini-css-extract-plugin
export var body = "AuthErrorModal-module--body--83c11";
export var buttonsContainer = "AuthErrorModal-module--buttons-container--806c0";
export var errorIconContainer = "AuthErrorModal-module--error-icon-container--8bd2a";
export var modalBodyWrapper = "AuthErrorModal-module--modal-body-wrapper--52c8e";
export var modalContent = "AuthErrorModal-module--modal-content--bf3a3";
export var title = "AuthErrorModal-module--title--24c1f";